
import * as React from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router-dom";
import SignUp from "@/components/onboarding/SignUp";
import RejectedScreen from "@/components/journey/RejectedScreen";
import MembershipBenefitsScreen from "@/components/onboarding/MembershipBenefitsScreen";
import ErrorScreen from "@/components/journey/ErrorScreen";
import NotifyScreen from "@/components/journey/NotifyScreen";
import ViewLandlordOffer from "./components/journey/ViewLandlordOffer";
import Layout from "@/components/layout";
import FAQScreen from "@/components/journey/FAQScreen";
import CongratsScreen from "@/components/journey/CongratsScreen";
import ByeUserScreen from "@/components/journey/ByeUserScreen";
import HomeScreen from "@/b2b/pages/HomeScreen.jsx";
import PartnerScreen from "@/b2b/pages/PartnerScreen.jsx";
import DynamicGuardedScreen from "@/components/common/screens/DynamicGuardedScreen";
import DynamicHomeScreen from "@/components/common/screens/DynamicHomeScreen";
import SuccessScreen from "@/components/journey/SuccessScreen";
import ProcessingScreen from "@/components/journey/ProcessingScreen";
import LoadingScreen from "./components/common/screens/LoadingScreen";
import TransitionWrapper from "./components/TransitionWrapper";
import { AnimatePresence } from "framer-motion";
import ReferScreen from "@/components/journey/ReferScreen";
import ReferHistoryScreen from "@/components/journey/ReferHistoryScreen";
import NewBenefits from "./components/onboarding/NewBenefits";
import { ThemeProvider } from "@/b2b/context/ThemeContext";
import RentingStatusScreen from "./components/onboarding/RentingStatusScreen";
import LandlordProceed from "./components/journey/LandlordProceed";
import StartScreen from "@/components/onboarding/StartScreen";
import InviteAcceptanceScreen from "@/components/landlord/InviteAcceptanceScreen";
import LandlordBenefits from "@/components/landlord/LandlordBenefits";
import PlatformChargesScreen from "@/components/landlord/PlatformChargesScreen";
import VishalSteps from "@/components/banking/home";
import WorkDetails from "@/components/banking/WorkDetails";
// import FlatmateInviteScreen from "@/components/onboarding/FlatmateInviteScreen";
import TenantTrackingScreen from "@/components/landlord/TenantTrackingScreen";
import FurtherSteps from "./components/journey/FurtherSteps";
import RedirectPage from "@/components/onboarding/RedirectPage";
import VerificationDoneScreen from "@/b2b/pages/VerificationDoneScreen";
import mixpanel from "mixpanel-browser";
import BankingLimitExceededScreen from "@/b2b/pages/BankingLimitExceededScreen";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import NewSplash from "./components/common/screens/newSplash";
import ClubWorkScreen from "./components/common/screens/ClubWorkScreen";
import CirclePeOffers from "./components/common/screens/calculatorScreen";
import ProcessDisbursal from "./components/banking/ProcessDisbursal";
import KYC from "./components/banking/kyc/index.jsx";
import PennyDrop from "./components/banking/bank_details/PennyDrop";
import BankDetails from "./components/banking/bank_details";
import RentSummary from "./components/banking/RentSummary";
import ESign from "./components/banking/esign";
import Mandate from "./components/banking/mandate";
// import Cards from "./components/common/screens/NewCarousel";
import AppDownloadBanner from "./components/common/DownloadAppBanner";

import NoAuthTransitionWrapper from "./components/NoAuthTransitionWrapper";
import  config  from "@/config";
import { PostHogProvider } from 'posthog-js/react';

import { useSocket } from "@/socketprovider";
import GlobalSocketHandler from "./globalsocket";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
      cacheTime: 1000 * 60 * 10, // Data is cached for 10 minutes
      refetchOnWindowFocus: false, // Disable refetch on window focus
    },
  },
});

// const screens = {
//   path: "/sign-up",
//   handleNext: () => {},
//   screens: [
//     {
//       heading: "Benefits for Tenants",
//       url: "https://www.youtube.com/embed/b8Ucv-ExOEU?autoplay=1&controls=1&enablejsapi=1&modestbranding=1&showinfo=0&rel=1&iv_load_policy=3",
//       thumbnail: "https://img.youtube.com/vi/b8Ucv-ExOEU/maxresdefault.jpg",
//       desc: [
//         "Connect us with your new landlord before moving in",
//         "We share the invite to your landlord & offer exclusive benefits",
//         "We get in touch with your landlord & onboard them on the Club",
//       ],
//     },
//     {
//       heading: "Benefits for Landlords",
//       url: "https://www.youtube.com/embed/bxW_NvPmQOU?autoplay=1&controls=1&enablejsapi=1&modestbranding=1&showinfo=0&rel=1&iv_load_policy=3",
//       thumbnail: "https://img.youtube.com/vi/bxW_NvPmQOU/maxresdefault.jpg",
//       desc: [
//         "9-months Rent in Advance: Of the entire lease (Non-Refundable)",
//         "Company Guarantee: Of 1-month’s rent to cover any damages",
//         "We Find New Tenants: On every renewal & save money on brokerage",
//         "Normal Rent Agreement: No master-lease/Sub-lease",
//         "Move In & Move Out Report: Along with deep cleaning & full management"
//       ],
//     },
//   ],
// };

const newSpalhConfig = {
  title: "How It Works?", // Title dynamically rendered
  tenant: {
    youtubeUrl:
      "https://www.youtube.com/embed/b8Ucv-ExOEU?autoplay=1&controls=1&enablejsapi=1&modestbranding=1&showinfo=0&rel=1&iv_load_policy=3",
    thumbnailUrl: "https://img.youtube.com/vi/b8Ucv-ExOEU/maxresdefault.jpg",
  },
  landlord: {
    youtubeUrl:
      "https://www.youtube.com/embed/bxW_NvPmQOU?autoplay=1&controls=1&enablejsapi=1&modestbranding=1&showinfo=0&rel=1&iv_load_policy=3",
    thumbnailUrl: "https://img.youtube.com/vi/bxW_NvPmQOU/maxresdefault.jpg",
  },
  points: [
    "After finalising a property, share the Club invite with your new landlord.",
    "We onboard your landlord with exclusive club benefits & enable Zero Deposit.",
  ],
};



const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ThemeProvider>
        <GlobalSocketHandler/>
        <Layout />
      </ThemeProvider>
    ),
    children: [
//       {
//   path: "/",
//   element: (
//     <TransitionWrapper>
//       <QueryClientProvider client={queryClient}>
//         {localStorage.getItem("isWeb") === "true" ? (
//           <DynamicHomeScreen />
//         ) : (
//           <RedirectPage />
//         )}
//       </QueryClientProvider>
//     </TransitionWrapper>
//   ),
//   index: true,
// },

      {
  path: "/",
  element: (
    <TransitionWrapper>
      <QueryClientProvider client={queryClient}>
          <DynamicHomeScreen />
      </QueryClientProvider>
    </TransitionWrapper>
  ),
  index: true,
},
      {
        path: "/b/:userIdentifier",
        element: (
          <ThemeProvider>
            <NoAuthTransitionWrapper>
              <HomeScreen />
            </NoAuthTransitionWrapper>
          </ThemeProvider>
        ),
        index: true,
      },
      {
        path: "/landlord",
        element: (
          <TransitionWrapper>
            <StartScreen customNextPath={"/benefits"} />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/p/:userIdentifier",
        element: (
          <ThemeProvider>
            <NoAuthTransitionWrapper>
              <PartnerScreen />
            </NoAuthTransitionWrapper>
          </ThemeProvider>
        ),
        index: true,
      },
      {
        path: "/l",
        element: (
          <TransitionWrapper>
            <StartScreen customNextPath={"/benefits"} />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/benefits",
        element: (
          <TransitionWrapper>
            <LandlordBenefits />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/platform-charges",
        element: (
          <TransitionWrapper>
            <PlatformChargesScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/accept-invite",
        element: (
          <TransitionWrapper>
            <InviteAcceptanceScreen />
          </TransitionWrapper>
        ),
        index: true,
      },

      {
      path: "/redirect",
      element: (
        <TransitionWrapper>
          <RedirectPage />
        </TransitionWrapper>
      ),
    },
      {
        // Where a KYC / mandate tab ends (cpcore's selfie relay sends it here). No login: the
        // tab may not share the journey's session.
        path: "/verification-done",
        element: (
          <NoAuthTransitionWrapper>
            <VerificationDoneScreen />
          </NoAuthTransitionWrapper>
        ),
      },
      // {
      //   path: "/flatmate-invite",
      //   element: (
      //     <TransitionWrapper>
      //       <FlatmateInviteScreen />
      //     </TransitionWrapper>
      //   ),
      //   index: true,
      // },
      {
        path: "/track-tenant",
        element: (
          <TransitionWrapper>
            <TenantTrackingScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/sign-up",
        element: (
          <TransitionWrapper>
            <SignUp />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/refer",
        element: (
          <TransitionWrapper>
            <ReferScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/refer-history",
        element: (
          <TransitionWrapper>
            <ReferHistoryScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/loading",
        element: <LoadingScreen />,
      },
      // {
      //   path: "/invite",
      //   element: (
      //     <TransitionWrapper>
      //       <ClubInviteScreen />
      //     </TransitionWrapper>
      //   ),
      //   index: true,
      // },
      {
        path: "/renting-status",
        element: (
          <TransitionWrapper>
            <RentingStatusScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/error",
        element: (
          <TransitionWrapper>
            <ErrorScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/charges",
        element: <CirclePeOffers />,
        index: true,
      },
      {
        path: "/new-benefits",
        element: (
          <TransitionWrapper>
            <NewBenefits />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/success",
        element: (
          <TransitionWrapper>
            <SuccessScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/congrats",
        element: <CongratsScreen />,
        index: true,
      },
      {
        path: "/declined",
        element: (
          <TransitionWrapper>
            <RejectedScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/membership-benefits",
        element: (
          <TransitionWrapper>
            <MembershipBenefitsScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/steps",
        element: (
          <TransitionWrapper>
            <FurtherSteps />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/notify",
        element: (
          <TransitionWrapper>
            <NotifyScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/processing-screen",
        element: (
          <TransitionWrapper>
            <ProcessingScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/faq",
        element: (
          <TransitionWrapper>
            <FAQScreen />
          </TransitionWrapper>
        ),
      },
      {
        path: "/:screenId",
        element: (
          <TransitionWrapper>
            <DynamicGuardedScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/home",
        element: (
          <TransitionWrapper>
            <DynamicHomeScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/bye",
        element: (
          <TransitionWrapper>
            <ByeUserScreen />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/onboarding",
        element: (
          <TransitionWrapper>
            <VishalSteps />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/processing",
        element: <ProcessDisbursal />,
        index: true,
      },
      {
        path: "/kyc",
        element: <KYC />,
        index: true,
      },
      // {
      //   path:"/realtime-account-verification",
      //   element:<RealtimeAccountVerification />,
      //   index: true,
      // },
      {
        path: "/work-details",
        element: (
          <TransitionWrapper>
            <WorkDetails />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/rent-summary",
        element: (
          <TransitionWrapper>
            <RentSummary />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/view-landlord",
        element: (
          <TransitionWrapper>
            <LandlordProceed />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/penny-drop",
        element: (
          <TransitionWrapper>
            <PennyDrop />
          </TransitionWrapper>
        ),
        index: true,
      },
      {
        path: "/banking",
        element: (
          <TransitionWrapper>
            <BankDetails />
          </TransitionWrapper>
        ),
      },
      {
        path: "/banking-limit",
        element: (
          <TransitionWrapper>
            <BankingLimitExceededScreen />
          </TransitionWrapper>
        ),
      },
      {
        path: "/esign",
        element: (
          <TransitionWrapper>
            <ESign />
          </TransitionWrapper>
        ),
      },
      {
        path: "/work",
        element: <ClubWorkScreen />,
        index: true,
      },
      
      // {
      //   path: "/video-splash",
      //   element: (
      
      //       <VideoExplainer
      //         screens={screens.screens}
      //         total={screens.steps}
      //         handleNext={screens.handleNext}
      //         path={screens.path}
      //       />
      
      //   ),
      //   index: true,
      // },
      {
        path: "/esign",
        element: <ESign />,
      },
      {
        path: "/mandate",
        element: <Mandate />,
      },
      {
        path: "/new-splash",
        element: <NewSplash config={newSpalhConfig} />,
        index: true,
      },
      {
        path: "/view-offer",
        element: <ViewLandlordOffer />,
        index: true,
      },
      // {
      //   path: "/new-splashh",
      //   element: <Cards/>,
      //   index: true,
      // },
      // {
      //   path: "/alt-phone",
      //   element: <AltPhoneScreen />, 
      //   index: true,
      // },
    ],
  },
  {}
]);
export default router;